import React from 'react';
import PropTypes from 'prop-types';
import Validation from '../../Validation/Validation';
import MainSelect from '../../MUI/MainSelect';

const SelectWithValidation = ({
  formProps,
  options,
  value,
  onChange,
  getMenuLabel,
  label,
  id,
  name,
  size,
  variant,
  required,
  disabled,
}) => {
  const { errors, clearError } = formProps;

  return (
    <Validation name={name} errors={errors} clearError={clearError}>
      <MainSelect
        required={required}
        getMenuLabel={getMenuLabel}
        options={options}
        onChange={onChange}
        label={label}
        id={id}
        value={value}
        size={size}
        variant={variant}
        name={name}
        disabled={disabled}
        errors={errors}
      />
    </Validation>
  );
};

SelectWithValidation.propTypes = {
  formProps: PropTypes.shape({
    errors: PropTypes.shape({}),
    clearError: PropTypes.func,
  }).isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.shape({})]),
  onChange: PropTypes.func.isRequired,
  getMenuLabel: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  label: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  variant: PropTypes.string,
  required: PropTypes.bool,
  disabled: PropTypes.bool,
};

SelectWithValidation.defaultProps = {
  label: '',
  id: '',
  size: 'small',
  variant: 'outlined',
  required: false,
  disabled: false,
  value: '',
};

export default SelectWithValidation;
